'use client';

import { useMemo } from 'react';
import EbvTraitExplanationPopover from './EbvTraitExplanationPopover';
import {
  parseEbvTraitExplanations,
  type EbvTraitHeaderContext,
} from './ebvTraitExplanations';
import { useEbvTraitExplanationPopover } from './useEbvTraitExplanationPopover';

type SocietySettingLike = {
  societySettingType?: string | null;
  value?: string | null;
};

export function useEbvTraitExplanations(
  settings?: SocietySettingLike[] | null,
  showBreedplanHelp = true,
) {
  const traitExplanationsByKey = useMemo(
    () => parseEbvTraitExplanations(settings),
    [settings],
  );

  const {
    popoverAnchor,
    popoverEntry,
    openPopover,
    handleInfoClick,
    handlePopoverClose,
  } = useEbvTraitExplanationPopover();

  const traitHeaderContext = useMemo((): EbvTraitHeaderContext => {
    return {
      traitExplanationsByKey,
      onTraitInfoClick: handleInfoClick,
    };
  }, [traitExplanationsByKey, handleInfoClick]);

  const popoverElement =
    traitExplanationsByKey.size > 0 ? (
      <EbvTraitExplanationPopover
        open={openPopover}
        anchorEl={popoverAnchor}
        onClose={handlePopoverClose}
        entry={popoverEntry}
        showBreedplanHelp={showBreedplanHelp}
      />
    ) : null;

  return {
    traitExplanationsByKey,
    traitHeaderContext,
    popoverElement,
    handleInfoClick,
    popoverAnchor,
    popoverEntry,
    openPopover,
    handlePopoverClose,
  };
}
